import React from 'react';

import MainTextfield from 'components/textfield/MainTextfield';
import MainAdornment from 'components/textfield/MainAdornment';

const PrepareTimeStep = ({ timeToPrepare, setTimeToPrepare, errorMessage }) => {
  const _onChange = (value) => {
    const newValue = !value ? '' : parseInt(value);
    setTimeToPrepare(newValue);
  };

  return (
    <MainTextfield
      type="number"
      value={!timeToPrepare ? '' : parseInt(timeToPrepare)}
      onChange={(e) => _onChange(e.target.value)}
      endAdornment={<MainAdornment position="end">minutes</MainAdornment>}
      fullWidth={true}
      label={'Preparation time'}
      error={!!errorMessage}
      helperText={errorMessage}
    ></MainTextfield>
  );
};

export default PrepareTimeStep;
